import React from 'react';
import PropTypes from 'prop-types';

import { privacyPolicyUrl } from '../../constants/globals';

import style from './style.scss';

export default class MarketingPermission extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    };
  }

  toggleCheckboxChange = event => {
    const { onChange } = this.props;
    this.setState(({ isChecked }) => ({ isChecked: !isChecked }));

    onChange(event);
  };

  render() {
    const { isChecked } = this.state;

    return (
      <div className={style.marketingPermission}>
        <p>
          What Car? would like to stay in touch by email to let you know about
          our latest products, promotions and other services.
        </p>
        <div className={style.checkbox}>
          <input
            type="checkbox"
            id="marketingPermission"
            name="marketingPermission"
            value={isChecked}
            checked={isChecked}
            onChange={this.toggleCheckboxChange}
          />
          <label htmlFor="marketingPermission">
            If you would prefer NOT to receive such email messages from us,
            please check this box
          </label>
        </div>
        <p>
          You can stop emails at any time using the unsubscribe link. We will
          use your information to ensure you receive messages that are relevant.
          Please see our{' '}
          <a href={privacyPolicyUrl} rel="noopener noreferrer" target="_blank">
            privacy notice
          </a>
          .
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MarketingPermission/index.js